export default __webpack_public_path__ + "static/media/ecash-logo-background.2cf720a3.png";